import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/StatusAlert'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { statusAlert } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = statusAlert.name
  static widget = Widget
  static configure = createConfigure(statusAlert)
}
